import { GpsAddressError, GPS_ADDRESS_MESSAGES } from './gpsAddress';

/** Não solicita coordenadas sem um provedor web de geocodificação configurado. */
export const lookupGpsAddress = async (_signal: AbortSignal): Promise<string> => {
  throw new GpsAddressError(GPS_ADDRESS_MESSAGES.web);
};
